<template>
    <a-modal
    :title="title"
    v-model="modalShow"
    width="600px"
    @cancel="close"
    :footer="null"
    destroyOnClose>
        <a-form-model
        v-if="dialogType!='detail'"
            class="common-form-inline"
            :rules="ruleForm"
            ref="ruleForm"
            :model="pageData"
            :label-col="{ span: 4}"
            :wrapper-col="{ span: 13 }"
            >
            <a-row :gutter="24">
                <a-col :span="24">
                    <a-form-model-item label="凭证类型" prop="documentType">
                        <a-radio-group v-model="pageData.documentType">
                            <a-radio v-for="item in VoucherDocumentTypeList" :key="item.dctVal" :value="item.dctVal" >{{item.dctValNm}}</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item label="凭证编号" prop="voucherCode">
                        <a-input v-model="pageData.voucherCode" @blur="getTableList" placeholder="请输入"/>
                    </a-form-model-item>
                </a-col>
                <a-col :span="24">
                    <a-form-model-item label="附件上传" prop="fileId">
                        <div style="position:relative">
                            <fileUpload accept=".png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.pdf,.PDF"
                            ref="fileUpload"
                            :paramObj="uploadParam"
                            @uploadOk="uploadOk"
                            @handleFileRemove="removeOk"
                            :removeaction="true"
                            name="file"/>
                            <div class="text-color-orange img-tip">注：附件支持图片及pdf格式，且大小不可超过30M</div>
                        </div>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
        <div v-if="dialogType!='detail'" class="spaceCenter" style="margin-bottom:16px;">
            <button-load @clickHandle="save" type="primary" lable="导入列表"/>
        </div>
        <div class="table-common common">
            <a-table
                :loading="tableLoading"
                size="middle"
                :columns="columns"
                :row-key="record => record.id"
                :data-source="tableData"
                :pagination="false"
                bordered
                :locale="{emptyText: '暂无数据'}"
            >
                <template slot="documentType" slot-scope="text">{{text | dictFilter(VoucherDocumentTypeList)}}</template>
                <template slot="createTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd')}}</template>
                <template slot="oper" slot-scope="text,record,index">
                    <span class="text-color-red pointer" v-if="dialogType!='detail'" @click="delFun(record,index)">撤销</span>
                    <a @click="downloadFile(record.file)">下载附件</a>
                </template>

            </a-table>
        </div>
    </a-modal>
</template>

<script>
import {mapGetters} from "vuex"
import {addBatchVoucher, addVoucher,deleteVoucherById,getVoucherList} from "@/api/payable.js"
import {fileSaveAPI} from "@/api/file.js"
import {mapActions} from "vuex"
export default {
    props:{
        info:{
            type:[Object],
            default:function(){
                return {}
            }
        },
    },
    components: {  },
    name:"invoice-info-dialog",
    data() {
        return {
            titleMap:{
                'add':'相关凭证-上传',
                'edit':'相关凭证-编辑',
                'detail':'相关凭证-查看'
            },
            title:"相关凭证-上传",
            dialogType:'add',
            invData:{},
            invDataList:[],
            readonly:false,
            modalShow:false,
            tableLoading:false,
            tableData:[],
            uploadParam:{
                app:"portal-pc",
                module:"payable",
                user:this.$store.getters["home/getUserHeader"].realname,
                tblBlId:this.utils.guid(32, 16),
                mdlId:"payable"
            },
            VoucherDocumentTypeList:[],
            pageData:{
                file:null,
                fileId:undefined,
                documentType:'1',
                voucherCode:undefined
            },
            voucherCodeValidate:false,
            ruleForm:{
                documentType:[
                    { required: true, message: '凭证类型不能为空', trigger: 'change' }
                ],
                voucherCode:[
                    {   required: true, trigger: 'blur',
                        validator:(rule,value,cbfn) => {
                            if (!value) {
                                cbfn('凭证编号不能为空');
                            }
                            else if(this.voucherCodeValidate){
                                cbfn('此凭证编号已关联祺信，不可再次使用');
                            }
                            else{
                                cbfn();
                            }
                        } }
                ],
                fileId:[
                    { required: true, trigger: 'change',
                        validator:(rule,value,cbfn) => {
                            if (!this.pageData.fileId) {
                                cbfn('请上传附件');
                            }
                            else{
                                cbfn();
                            }
                        }
                    }
                ],
            },
            columns:[
                {
                    title: "凭证类型",
                    dataIndex: "documentType",
                    scopedSlots: { customRender: "documentType" },
                },
                {
                    title: "凭证编号",
                    dataIndex: "voucherCode"
                },
                {
                    title: "上传人",
                    dataIndex: "createUser"
                },
                {
                    title: "上传日期",
                    dataIndex: "createTime",
                    scopedSlots: { customRender: "createTime" },
                },
                {
                    title: "操作",
                    dataIndex: "oper",
                    scopedSlots: { customRender: "oper" },
                }
            ],
            fileReadonly:false,
        }
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj",

        }),
        showList(){
            if(!this.pageData.file){
                return [];
            }else{
                return [this.pageData.file];
            }
        }
    },
    created() {
        this.getDicAsync("VoucherDocumentType").then(res => {
            this.VoucherDocumentTypeList = res;
        })
    },
    methods: {
        ...mapActions({
            getDicAsync:"app/getDicAsync"
        }),
        open({invData,invDataList,dialogType,voucherList}){
            /**
             * @params{dialogType} add\edit\detail
             */
            console.log(invDataList)
            this.dialogType = dialogType || 'add';
            this.title = this.titleMap[dialogType];
            this.invData = this.utils.deepClone(invData || {});
            this.invDataList = this.utils.deepClone(invDataList || {});
            this.readonly = dialogType == 'add' ? false : true;
            this.modalShow = true;
            if(voucherList){
                this.tableData = voucherList;
                return;
            }
            else if(dialogType != 'add'){
                this.getInfo();
            }
            console.log(invDataList)
        },
        getInfo(){
            this.tableLoading = true;
            getVoucherList({
                cyCode:this.invData.cyCode
            }).then(res => {
                this.tableData = res.data||[];
                this.tableLoading = false;
            })
        },
        getTableList(){
            this.voucherCodeValidate = false;
            if(!this.pageData.voucherCode) return;
            let inItem = this.tableData.find(i => i.voucherCode == this.pageData.voucherCode);
            if(inItem){
                return;
            }
            this.tableLoading = true;
            getVoucherList({
                voucherCode:this.pageData.voucherCode,
                sellerOrgCode:this.invData.sellrOrgCode,
                buyerOrgCode:this.invData.buryOrgCode
            }).then(res => {
                this.tableLoading = false;
                let item = res.data[0];
                if(item){
                    if(item.payableAmount != item.canEstbGldBal){
                        // 存在开立祺信在途业务
                        this.voucherCodeValidate = true;
                        this.$refs.ruleForm&&this.$refs.ruleForm.validateField("voucherCode");
                        return;
                    }
                    let params = {
                        documentType:item.documentType,
                        fileId:item.fileId,
                        voucherCode:item.voucherCode,
                        sellerOrgCode:this.invData.sellrOrgCode,
                        buyerOrgCode:this.invData.buryOrgCode,
                        cyCode:this.invData.cyCode,
                    }
                    addVoucher(params).then(res => {
                        this.getInfo();
                        this.$emit("save");
                    })
                }
            }).catch(err => {
                console.log(err)
            })
        },
        close(){
            this.pageData = {
                file:null,
                fileId:undefined,
                documentType:'1',
                voucherCode:undefined
            };
            this.tableData = [];
            this.$refs.ruleForm&&this.$refs.ruleForm.resetFields();
            this.modalShow = false;
        },
        // 删除文件
        removeOk(){
            this.pageData.file = null;
            this.pageData.fileId = undefined;
        },
        fileSave(data){
            const param = {
                fileNm: data.name,
                fileSize: data.size,
                fileRte: data.fileRte,
                fileExpdNm: data.fileExpdNm,
                tblBlId: this.uploadParam.tblBlId,
                mdlId: 'payable',
            }
            fileSaveAPI(param)
            .then(res => {
                this.uploading = false;
                this.pageData.fileId = res.data.fileId;
                this.pageData.file = data;
                this.$refs.ruleForm&&this.$refs.ruleForm.validateField("fileId");
            })
            .catch(err => {
                this.uploading = false;
                console.log(err);
            })
        },
        uploadOk(resList){
            this.fileSave(resList[0]);
        },
        initData(){
            this.pageData = {
                file:null,
                fileId:undefined,
                documentType:'1',
                voucherCode:undefined
            };
            this.$refs.fileUpload.setFileList();
        },
        delFun(record,index){
            const self = this;
            this.$confirm({
                title: '撤销',
                content: "您正在进行撤销操作，是否确认？",
                onOk() {
                    deleteVoucherById({
                        id:record.id
                    }).then(res => {
                        self.$message.success("撤销成功");
                        self.tableData.splice(index,1);
                        self.$emit("save");
                    })
                },
                onCancel() {},
            })
        },
        save(btn){
            let inItem = this.tableData.find(i => i.voucherCode == this.pageData.voucherCode);
            if(inItem){
                this.$message.warn("凭证信息已在列表中，不可重复提交");
                btn&&btn.closeLoad();
                return;
            }
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    // let params = {
                    //     ...this.pageData,
                    //     sellerOrgCode:this.invData.sellrOrgCode,
                    //     buyerOrgCode:this.invData.buryOrgCode,
                    //     cyCode:this.invData.cyCode,
                    // }

                    let listStr = [];
                    this.invDataList.forEach((item, index) => {
                      listStr.push({
                        ...this.pageData,
                        sellerOrgCode:item.sellrOrgCode,
                        buyerOrgCode:item.buryOrgCode,
                        cyCode:item.cyCode,
                      })
                    })
                    addBatchVoucher({listStr : JSON.stringify(listStr)}).then(res => {
                        this.$message.success("操作成功");
                        btn&&btn.closeLoad();
                        this.initData();
                        this.getInfo();
                        this.$emit("save");
                    }).catch(err => {
                        btn&&btn.closeLoad();
                        console.log(err)
                    })
                }else{
                    btn&&btn.closeLoad();
                }
            });
        },
        downloadFile(item){
            const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install';
            window.open(`${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm||item.name}`, '_blank');
        }
    },
    watch: {
    },
    activated() {}
}
</script>
<style scoped lang="less">
    .img-tip{
        white-space: nowrap;
        position: absolute;
        left:120px;
        font-size: 12px;
        top:0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/delivery-voucher-dialog.vue